module.exports = __webpack_public_path__ + "img/3-fourImg.0801f0ea.png";